import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import Button from "theme/components/atoms/Button";
import useActiveTab from "./useActiveTab";
import { useLocation } from "react-router";

const Tabs = ({ tabs, id }) => {
  const controlsRef = useRef();
  const activeTabRef = useRef();

  const displayedTabs = tabs.filter(Boolean);

  const [activeKey, setActiveKey] = useActiveTab(
    displayedTabs,
    controlsRef,
    activeTabRef
  );

  const location = useLocation();
  const hash = location.hash;
  const key = location.key;
  useEffect(() => {
    if (hash === `#${activeKey}` && controlsRef.current) {
      controlsRef.current.scrollIntoView();
    }
  }, [activeKey, hash, key]);

  if (displayedTabs.length <= 0) {
    return null;
  }

  return (
    <div className="tabs">
      <div className="tabs__head">
        <div className="tabs__controls" ref={controlsRef} role="tablist">
          {displayedTabs.map(({ key, label }) => {
            /* The direct child returned here must be a button for correct use in a11y */
            return (
              <Button
                appearance={activeKey === key ? "default" : "ghost"}
                size="big"
                key={key}
                onClick={() => setActiveKey(key)}
                role="tab"
                aria-selected={activeKey === key}
                aria-controls={`tabs-${id}--panel-${key}`}
                id={`tabs-${id}--key-${key}`}
              >
                {label}
              </Button>
            );
          })}
        </div>
      </div>
      {displayedTabs.map(({ key, children }) => (
        <div
          className={classNames("tabs__content", {
            "tabs__content--active": activeKey === key,
          })}
          ref={activeKey === key ? activeTabRef : undefined}
          hidden={activeKey !== key}
          key={key}
          tabIndex="-1"
          role="tabpanel"
          id={`tabs-${id}--panel-${key}`}
        >
          {children}
        </div>
      ))}
    </div>
  );
};

Tabs.defaultProps = {
  id: "0",
};

export default Tabs;
